/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ProductDtoBase } from "./ProductDtoBase";

export class RoofLightProductDto extends ProductDtoBase {
    minWidth: number;
    maxWidth: number;
    minDepth: number;
}
